import {Injectable} from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';

declare const angular: any;

@Injectable()
export class ValidationService {

  ajsService: any;

  validationCtrlValues = {};

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('ValidationService');
    this.validationCtrlValues = this.ajsService.validationCtrlValues;
  }

  loadValidators(componentDef, fieldName) {
    return this.ajsService.loadValidators(componentDef, fieldName);
  }
}
